<template>
  <div class=" w-100">
    <div class="imageTemplate mb-4" v-if="template.templateId">
      <div class="imageTemplate__actions">
        <CButton v-if="view" color="transparent" class="imageTemplate__button" @click="modal = !modal">{{
          $t('campaign.creator.blockLibrary.email-content.view')
        }}</CButton>
        <CButton
          v-else-if="emailSimpleText"
          color="transparent"
          :to="{
            name: 'simple-text',
            params: {
              id: template.templateId,
              campaignId: this.$route.params.campaignId,
              indexChannel: indice,
              contentType: template.contentType,
            },
          }"
          class="imageTemplate__button"
          >{{ $t('campaign.creator.blockLibrary.email-content.edit') }}</CButton
        >
        <CButton
          v-else
          color="transparent"
          :to="{
            name: 'edit-template-html',
            params: { id: template.templateId, campaignId: this.$route.params.campaignId, contentType: temaplate.contentType },
          }"
          class="imageTemplate__button"
          >{{ $t('campaign.creator.blockLibrary.email-content.edit') }}</CButton
        >
      </div>

      <div class="px-3 py-4 w-100 text-left box-text font-md">
        <p>
          <b>{{ templateName }}</b>
        </p>
        <p class="mb-0">
          {{ emailSimpleText }}
        </p>
      </div>
    </div>

    <CModal :title="templateName" color="secundary" :show.sync="modal" size="xl">
      <div class="text-left">
        <p>
          {{ emailSimpleText }}
        </p>
      </div>

      <template #footer>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  name: 'Simpletext',

  props: {
    template: {
      type: Object,
      require: true,
    },
    edit: {
      type: Boolean,
      default: () => false,
      require: true,
    },
    indexChannel: {
      type: Number,
      default: () => null,
    },
    view: {
      type: Boolean,
      default: () => false,
      require: true,
    },
  },

  data() {
    return {
      modal: false,
    }
  },

  computed: {
    templateName() {
      return this.template.templateName
    },

    emailSimpleText() {
      return this.template.emailSimpleText
    },

    indice() {
      return this.indexChannel
    },
  },
}
</script>

<style lang="scss" scoped>
.box-text {
  border: 1px solid $gray-100;
  color: $gray-600;
}

p {
  line-height: 16px;
}
</style>
